import { awaitSelector, watchAwaitSelector } from './functions'

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  watchAwaitSelector(function () {
    const accordion = document.querySelector('.Accordion')
    const gallery = document.querySelector('.Product__Gallery')

    if (accordion && gallery) {
      accordion.style.width = `${gallery.getBoundingClientRect().width}px`
    }

    if (accordion && gallery) {
      window.addEventListener('resize', function () {
        accordion.style.width = `${gallery.getBoundingClientRect().width}px`
      })
    }
  }, '#shopify-section-product-template-patterns .Accordion, #shopify-section-product-template-patterns .Product__Gallery, #shopify-section-product-template-books .Accordion, #shopify-section-product-template-books .Product__Gallery')
})
